<template>
    <div class="chart-block" style="min-height:297px">
              <h3>   <a :href="url" target="_blank"> {{chartName}}</a></h3>
        <div class="sale-ls-block">
            <div class="sale-ls-row lbl" >
                  <div class="item">&nbsp;</div>
               
                <div class="item">销量</div>
             
                <div class="item">环比</div>
                   <div class="item">同比</div>
                 <div class="item"> 份额</div>
            </div>
            <div class="sale-ls-row" v-for="( item,index) in tableData" :key="index">
                 <div class="item"> {{item.source}}</div>
                 <div class="item sales-item">{{item.sales}}</div>
                 <div class="item" v-html="pieFormatter(item.yoy)"> </div>
                 <div class="item" v-html="pieFormatter(item.mom)"> </div>
                 <div class="item"><span class="pie"> {{item.pie}}</span> </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                url:"",
                chartName: '新能源市场份额',
                tableData: [  {
                    source: '纯电动',
                    pie: '33.5%',
                    sales: 1186307,
                    mom: 0.45,
                    yoy: -0.11
                },{
                    source: '插电式',
                    pie: '33.5%',
                    sales: 21385,
                    mom: 0.15,
                    yoy: -0.11
                }, {
                    source: '增程式',
                    pie: '33.5%',
                    sales: 22476,
                    mom: 0.05,
                    yoy: 0.21
                }]
            }
        },
        methods:{
 
              pieFormatter(val)
              {
                  if(val>0)
                    return  '<span class="red">+' +(val *100)+'%<span>'
                    return  '<span class="green">' +(val *100)+'%<span>'
              }

        }
    }
</script>
<style scoped>
    .sale-ls-block {
        padding: 12px 20px;
        margin-top: 8px;
        font-size:13px;
    }
    .sale-ls-row {
        display: flex;
        height: 56px;
        border-bottom: 1px dashed #ccc;
    }
    .sale-ls-row:last-child {
        border-bottom: none !important;
    }
    .sale-ls-row .item {
        flex: auto;
        padding: 20px 10px;
    }
    .lbl .item{ font-weight:bolder;}
   .sale-ls-row .sales-item{
       font-size: 15px;
       font-weight:bolder;
       text-align:left;
       padding-left:16px
   }
    .sale-ls-row .item .pie{
        display: inline-block;
        background-color: #47bae7;
        line-height: 22px;
        color: #fff;
        padding:4px auto;
        width:60px;
    }
</style>